export default {
	login: 'krittiyaclark',
	id: 3038228,
	node_id: 'MDQ6VXNlcjMwMzgyMjg=',
	avatar_url: 'https://avatars1.githubusercontent.com/u/3038228?v=4',
	gravatar_id: '',
	url: 'https://api.github.com/users/krittiyaclark',
	html_url: 'https://github.com/krittiyaclark',
	followers_url: 'https://api.github.com/users/krittiyaclark/followers',
	following_url:
		'https://api.github.com/users/krittiyaclark/following{/other_user}',
	gists_url: 'https://api.github.com/users/krittiyaclark/gists{/gist_id}',
	starred_url:
		'https://api.github.com/users/krittiyaclark/starred{/owner}{/repo}',
	subscriptions_url: 'https://api.github.com/users/krittiyaclark/subscriptions',
	organizations_url: 'https://api.github.com/users/krittiyaclark/orgs',
	repos_url: 'https://api.github.com/users/krittiyaclark/repos',
	events_url: 'https://api.github.com/users/krittiyaclark/events{/privacy}',
	received_events_url:
		'https://api.github.com/users/krittiyaclark/received_events',
	type: 'User',
	site_admin: false,
	name: 'Krittiya Clark',
	company: null,
	blog: '',
	location: 'Vermont, USA',
	email: null,
	hireable: true,
	bio: 'HTML, CSS, SCSS, JS, React, Node, GIT',
	twitter_username: null,
	public_repos: 86,
	public_gists: 2,
	followers: 24,
	following: 32,
	created_at: '2012-12-14T00:28:10Z',
	updated_at: '2020-07-23T20:38:54Z',
}
